import request from '@/utils/request'

export function sendVerificationCode(obj) { //发送验证码 
  return request({
    url: '/market/promotion/sendVerificationCode.php',
    method: 'post',
    data:obj
  })
}

export function clueInputPromotionPage(obj) { //发送提交数据  
  return request({
    url: '/market/promotion/clueInputPromotionPage.php',
    method: 'post',
    data:obj
  })
}
export function clueInputCode(obj) { //线索录入[含兑换码] 
  return request({
    url: '/market/promotion/clueInput-Code.php',
    method: 'post',
    data:obj
  })
}


export function verificationCode(obj) { //生成图形验证码  
  return request({
    url: '/login/verificationCode',
    method: 'post',
    data:obj
  })
}
export function checkoutVerificationCode(obj) { //校验图形验证码  
  return request({
    url: '/login/checkoutVerificationCode',
    method: 'post',
    data:obj  
  })
}
export function pageClick(obj) { //页面打开统计接口
  return request({
    baseURL:"https://ol.stem.cn:8808/market/promotion/pageClick", 
    method: 'post',
    data:obj  
  })
}






